import { useState } from 'react';
import { SettingsModal } from '@/components/game/SettingsModal';

/**
 * Phase 15.1 — Dezenter Versions-Pill (unten links). Öffnet das SettingsModal,
 * das standardmäßig auf den "Über"-Tab springen würde — wir initialisieren
 * den Tab nicht explizit, weil das SettingsModal seinen Tab-State intern hält.
 *
 * (Alternative wäre, den Initial-Tab als Prop zu übergeben — bewusst KISS gehalten,
 * der User scrollt eine Tab-Klick weiter.)
 */
export function VersionPill() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Über Dispatch24 öffnen"
        aria-label={`Version ${__APP_VERSION__} — Über öffnen`}
        className="pointer-events-auto fixed bottom-2 left-2 z-30 rounded px-2 py-0.5 font-mono text-[10px] text-fg-muted opacity-60 transition hover:bg-bg-overlay/60 hover:text-fg-primary hover:opacity-100"
      >
        v{__APP_VERSION__}
        {__IS_BETA__ ? '-beta' : ''} · {__GIT_HASH__}
      </button>
      <SettingsModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
